import { useEffect, useState } from "react";
import { Clock, User } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { PageHero, Reveal, EmptyState } from "@/components/public/Shared";

export default function Ministries() {
  const [ministries, setMinistries] = useState(null);

  useEffect(() => {
    api.get("/public/ministries").then((r) => setMinistries(r.data)).catch(() => setMinistries([]));
  }, []);

  return (
    <div data-testid="ministries-page">
      <PageHero
        title="Our Ministries"
        subtitle="Opportunities to grow in faith, serve one another and bless our community."
        image="https://images.pexels.com/photos/4262416/pexels-photo-4262416.jpeg?auto=compress&cs=tinysrgb&w=1800"
      />
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24">
        {ministries && ministries.length === 0 && (
          <EmptyState
            testId="ministries-empty"
            title="Ministries coming soon"
            text="Details of our church ministries will be published here shortly."
          />
        )}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(ministries || []).map((m, i) => (
            <Reveal key={m.id} delay={i * 0.07}>
              <article
                className={`h-full rounded-lg border border-border bg-white p-8 shadow-sm transition-transform duration-300 hover:-translate-y-1 ${i % 5 === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
                data-testid={`ministry-card-${m.id}`}
              >
                {m.photo_url && (
                  <img src={fileUrl(m.photo_url)} alt={m.name} className="mb-5 h-40 w-full rounded-md object-cover" loading="lazy" />
                )}
                <h3 className="font-heading text-2xl font-bold text-navy">{m.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground whitespace-pre-line">{m.description}</p>
                <div className="mt-5 space-y-1.5 text-xs text-foreground/70">
                  {m.leader && <p className="flex items-center gap-2"><User className="h-3.5 w-3.5 text-gold" /> Leader: {m.leader}</p>}
                  {m.meeting_time && <p className="flex items-center gap-2"><Clock className="h-3.5 w-3.5 text-gold" /> {m.meeting_time}</p>}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
